import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
	overflow: auto;
	height: 100%;
	display: flex;
	justify-content: center;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 580px;
	margin-top: 120px;
	text-align: center;
`;

export const Title = styled.div`
	color: ${colors.black};
	margin-bottom: 8px;
	font-size: 28px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 35px;
	text-align: center;
`;

export const BodyText = styled.div`
	font-size: 16px;
	letter-spacing: 0.3px;
	color: ${colors.black};
	max-width: 500px;

	span {
		font-weight: bold;
	}
`;

export const TitleText = styled(BodyText)`
	font-size: 19px;
	margin-bottom: 16px;
`;

export const MessageWrapper = styled.div`
	border: 1px solid ${colors.grey2};
	padding: 32px 52px;
	margin: 32px;
	width: 553px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Link = styled.a`
	color: ${colors.green1};
	cursor: pointer;
	font-size: 19px;
	transition: all 0.2s linear 0s;
	margin-top: 24px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;

	&:hover {
		color: ${colors.green3};

		svg {
			fill: ${colors.green3};
		}
	}
`;
